import _ from 'lodash';

export const getMaxOrder = (items: { order?: number | null }[]) => {
  const orderValues = items
    .filter(({ order }) => !_.isNil(order))
    .map(({ order }) => order);

  return _.max(orderValues) ?? -1;
};
